/**
 * Given a set of heading IDs, returns all ancestor headings of each ID
 * according to the provided parentMap.
 */
const getAllAncestors = (selectedIds: string[], parentMap: Record<string, string | null>): Set<string> => {
  const result = new Set<string>();

  for (const id of selectedIds) {
    let current: string | null = id;
    while (current) {
      const parent = parentMap[current] as string | null;
      if (parent) {
        result.add(parent);
      }
      current = parent;
    }
  }
  return result;
};

export default getAllAncestors;
